import * as React from 'react';
import { FolderHeader } from '../../components/FolderHeader';
import { useDispatch, useSelector } from 'react-redux';
import { selectIsModalRemoveOpen, selectIsModalRenameOpen, selectSelectedFolder } from '../../selectors/folders';
import { ModalRemoveContainer, ModalRenameContainer } from './modals';
import { MenuContainer } from './menu';
import { getTextForShareFolder } from '../../thunk/favorites';
import { selectResults } from '../../selectors';
import { trackShareFolder } from './tracking';

export function FolderHeaderContainer() {
  const dispatch = useDispatch();

  const selectedFolder = useSelector(selectSelectedFolder);
  const isModalRenameOpen = useSelector(selectIsModalRenameOpen);
  const isModalRemoveOpen = useSelector(selectIsModalRemoveOpen);
  const { favoriteEntities } = useSelector(selectResults);

  const handleShare = React.useCallback(async () => {
    trackShareFolder(favoriteEntities);

    if (!selectedFolder) {
      return;
    }

    const text = await (dispatch(getTextForShareFolder(selectedFolder.id)) as unknown);
    if (text) {
      window.open(`https://wa.me/?text=${text}`, '_blank');
    }
  }, [dispatch, selectedFolder]);

  return (
    <React.Fragment>
      <FolderHeader
        text={selectedFolder ? selectedFolder.name : 'Все объявления'}
        menu={selectedFolder && <MenuContainer />}
        shareIsAvailable={Boolean(selectedFolder)}
        onClickShare={handleShare}
      />
      {isModalRenameOpen && <ModalRenameContainer />}
      {isModalRemoveOpen && <ModalRemoveContainer />}
    </React.Fragment>
  );
}
